var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"data-heading",class:{'data-heading--spaced': _vm.spaced}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.heading))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }